<template></template>
<script>
import * as api from "@/http/api.js";
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {};
    },
    created() {
        this.handleLogin();
    },
    methods: {
        /**
         * 路由跳转
         * params { url : 路由路径}
         */
        routerGo(url) {
            this.$router.push(url);
        },
        /**
         * 登录
         */
        handleLogin() {
            sessionStorage.setItem("activeSys", "");
            sessionStorage.setItem("tabList", []);
            this.rememberAccunt();
            api.submitLogin({
                login_name: this.$route.query.id,
                login_password: "!@#$%^&*()_+"
            }).then(res => {
                if (res && res.error_code === "0") {
                    sessionStorage.setItem("token", res.token);
                    sessionStorage.setItem("can_logout", "0");
                    sessionStorage.setItem("activeTab", "");
                    sessionStorage.removeItem("header-title");
                    this.getUserInfo();
                }
                this.disabled = false;
            });
        },
        /**
         * 获取用户信息
         */
        getUserInfo() {
            this.$store.dispatch("getUserInfo");
        },
        /**
         * 记住账号--加密
         */
        rememberAccunt() {
            if (this.checked) {
                const username = CryptoJS.AES.encrypt(
                    this.loginForm.login_name,
                    this.CRYPTOJSKEY
                ).toString();
                const password = CryptoJS.AES.encrypt(
                    this.loginForm.login_password,
                    this.CRYPTOJSKEY
                ).toString();
                this.$cookie.set("user", username + "-" + password, 30);
            } else {
                this.$cookie.delete("user");
            }
        }
    }
};
</script>
